/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent:require('../../../../model/banner/Banner'),
    mapping:{
        swiper:require('./Swiper')
    },
    method:{
        init:function () {
           nb.model.onChange(nb.opts.clientReady,function () {
               this.setOpts({
                   status:'full'
               });
           },this);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/banner/Banner.js
// module id = 522
// module chunks = 6